<template>
  <div>
    <!-- Form -->
    <form id="reset-password" class="std-form" v-if="resetTokenVerified === 1">
      <h2>Reset your password now!</h2>
      <div class="form-group">
        <label for="user-name">Username</label>
        <input type="text" id="user-name" v-model="userName" />
        <span class="field-info">
          (Your username may user upper/lower case letters, numbers, hyphens
          (-), underscoresd (_), "at" (@) and period(.). Maximum length :50
          characters.)
        </span>
      </div>
      <div class="form-group">
        <label for="user-pwd">Password</label>
        <input type="password" id="user-pwd" v-model="password" />
        <span class="field-info">
          (Your password must have between 7 &amp; 20 characters with a
          combination of letters, symbols or numbers. The strongest passwords
          are long and will have all of the above including upper and lower case
          letters.)
        </span>
      </div>
      <div class="form-group">
        <label for="user-pwd2">Retype Password</label>
        <input type="password" id="user-pwd2" v-model="retypePassword" />
      </div>
      <button
        @click.stop.prevent="resetPasswordLocal"
        type="submit"
        class="btn btn-secondary"
      >
        Reset
      </button>
    </form>

    <!-- Invalid token -->
    <div v-else-if="resetTokenVerified === -1">
      <h2 class="extra-margin">Invalid token</h2>
    </div>

    <!-- Loader -->
    <div class="loader-container" v-else>
      <loader-vue />
    </div>
  </div>
</template>

<script>
import LoaderVue from "../Appointment/common/Loader";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      userName: "",
      password: "",
      retypePassword: ""
    };
  },
  computed: {
    ...mapGetters("forgotPassword", {
      resetTokenVerified: "getResetTokenVerified",
      resetToken: "getResetToken"
    })
  },
  methods: {
    ...mapMutations("forgotPassword", {
      setResetToken: "setResetToken"
    }),
    ...mapActions("forgotPassword", {
      verifyResetToken: "verifyResetToken",
      resetPassword: "resetPassword"
    }),
    ...mapActions({
      globalMessagePopup: "globalMessagePopup"
    }),
    verifyUsername(username) {
      if (!/^[a-zA-Z\d_@.-]{1,50}$/.test(username.trim())) {
        this.globalMessagePopup("Invalid username");
        return false;
      }
      return username.trim();
    },
    verifyPassword(password, userName) {
      if (userName && password.length < 7 && password.length > 20) {
        this.globalMessagePopup("Invalid password");
        return false;
      } else if (!userName) {
        return false;
      }
      return password;
    },
    verifyRepeatPassword(password, repeatPassword) {
      if (password && password !== repeatPassword) {
        this.globalMessagePopup("Repeat password has to be same as password");
        return false;
      } else if (!password) {
        return false;
      }
      return repeatPassword;
    },
    resetPasswordLocal() {
      const userName = this.verifyUsername(this.userName);
      const password = this.verifyPassword(this.password, userName);
      const repeatPassword = this.verifyRepeatPassword(
        password,
        this.retypePassword
      );
      if (userName && password && repeatPassword) {
        this.resetPassword({
          userName: userName,
          password: password,
          repeatPassword: repeatPassword
        });
      }
    }
  },
  created() {
    this.setResetToken(this.$route.params.token);
    this.verifyResetToken();
  },
  watch: {
    resetToken(value) {
      if (value === false) {
        this.$router.push("/");
      }
    }
  },
  components: {
    LoaderVue
  }
};
</script>

<style scoped>
.extra-margin {
  margin: 20px;
}
</style>
